import { render, staticRenderFns } from "./EditOrg.vue?vue&type=template&id=33319b4e&scoped=true&"
import script from "./EditOrg.vue?vue&type=script&lang=js&"
export * from "./EditOrg.vue?vue&type=script&lang=js&"
import style0 from "./EditOrg.vue?vue&type=style&index=0&id=33319b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33319b4e",
  null
  
)

export default component.exports